module.exports = __webpack_public_path__ + "fonts/voicecall_ico@2x.6cced0f5506d1c0a2ee3b9388e64753f.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/voicecall_ico@2x.png
// module id = 778
// module chunks = 9